import { t } from "tbme/localization";

export const AnalyticEventName = {
  CONTENT_CLICK: "custEv_contentClick",
} as const;

export type AnalyticEventName = typeof AnalyticEventName[keyof typeof AnalyticEventName];

export const AnalyticsPageElement = {
  PROFILE_EDIT: "Profile Edit",
  SOCIAL_ACTION: "Social Action",
  SOCIAL_LINK: "Social Link",
} as const;

export type AnalyticsPageElement = typeof AnalyticsPageElement[keyof typeof AnalyticsPageElement];

export const AnalyticsLinkElementType = {
  LINK: "link",
  BUTTON: "button",
} as const;

export type AnalyticsLinkElementType = typeof AnalyticsLinkElementType[keyof typeof AnalyticsLinkElementType];

export interface AnalyticsLink {
  text: string;
  elementType: AnalyticsLinkElementType;
  url?: string;
}

export interface ProfileAnalyticEvent {
  event: AnalyticEventName;
  elementName: AnalyticsPageElement;
  link: AnalyticsLink;
}

/**
 * Sends a Profile analytics event to the data layer.
 * @param event - The name of the event to send.
 * @param elementName - The name of the element that was clicked.
 * @param linkLabel - The localization label of the link (E.g "aboutMe.edit"). The english value of this label will be sent to the data layer.
 * @param linkElementType - The type of the link to send.
 * @param linkUrl - The URL of the link to send. Optional.
 * @returns The Profile analytics event that was sent to data layer.
 */
export const sendProfileAnalyticsEvent = (
  event: AnalyticEventName,
  elementName: AnalyticsPageElement,
  linkLabel: string,
  linkElementType: AnalyticsLinkElementType,
  linkUrl?: string
): ProfileAnalyticEvent => {
  const linkText = t(linkLabel, { locale: "en" });

  const profileAnalyticsEvent: ProfileAnalyticEvent = {
    event: event,
    elementName: elementName,
    link: {
      text: linkText,
      elementType: linkElementType,
      ...(linkUrl ? { url: linkUrl } : {}),
    },
  };
  window.dataLayer?.push(profileAnalyticsEvent);
  return profileAnalyticsEvent;
};
